import { NgIf, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CartLine, OrderTypes } from '@next/core-lib/cart';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, AgrDialogModule } from '@next/core-lib/dialog';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';

interface OrderTypeSwitchDialogData extends AbstractDialogData {
  changeFrom: OrderTypes;
  changeTo: OrderTypes;
  cartEligibleForChange: boolean;
  cartlinesToRemove: CartLine[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ordertype-switch-dialog.component.html',
  imports: [AgrDialogModule, NgIf, NgFor, AgrI18nSharedModule],
})
export class OrderTypeSwitchDialogComponent extends AbstractDialog<OrderTypeSwitchDialogData> {
  constructor(
    protected mdDialogRef: MatDialogRef<OrderTypeSwitchDialogComponent, AbstractDialogResultData<OrderTypeSwitchDialogData>>,
    @Inject(MAT_DIALOG_DATA) public data: OrderTypeSwitchDialogData,
    public readonly locale: LocaleService,
  ) {
    super();
  }
}
